import React from "react"

function LinesBackground() {
  return (
    <div className="absolute top-0 left-0 flex h-full w-full justify-between">
      <div className="vertical-line" />
      <div className="vertical-line" />
      <div className="vertical-line" />
      <div className="vertical-line" />
      <div className="vertical-line hidden lg:block" />
      <div className="vertical-line hidden lg:block" />
    </div>
  )
}

export default LinesBackground
